import {
    Box,
    Typography
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import {useAuth} from '../../hooks/useAuth';

export const FooterComponent = () => {

  const {accessToken} = useAuth();

  return (
    //maybe use position: "fixed" in the future within sx
     <Box sx={{bottom: 0,
               width: '100%'}}>
        {/*
        <Typography sx={{wordWrap: "break-word"}}>
           Current User: {accessToken}
        </Typography>
        */}
     </Box>

);
};
